import React from "react"
import { injectIntl, WrappedComponentProps } from "gatsby-plugin-intl"
import SEO from "../components/seo"

const Redirect = ({ intl }: React.PropsWithChildren<WrappedComponentProps>) => {
  return <SEO title={`${intl.formatMessage({ id: "title" })}`} />
}

export default injectIntl(Redirect)
